import React, { FormEvent, useState, useContext } from "react";
import AuthContext from "../../../contexts/AuthContext";
import { RouteProps } from "react-router-dom";

import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";

import { SimpleResponse } from "../../../services/api/Request";
import Year, { IYear } from "../../../services/api/Year";
import { SetModal } from "../../../components/Modal";
import Checkbox from "../../../components/Form/Checkbox";

interface FormProps extends RouteProps {
  year: IYear;
}

const Form: React.FC<FormProps> = ({ year }) => {
  const { user } = useContext(AuthContext);
  const readOnly = user!.profile.name === "Viewer";
  const [response, setResponse] = useState<SimpleResponse>();
  const isUpdate = year && year.id;

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();

    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {};
    formData.forEach((value: FormDataEntryValue, key: string) => {
      data[key] = value;
    });

    const response: SimpleResponse = await (isUpdate
      ? Year.Update(year.id, data)
      : Year.Create(data));

    setResponse(response);
  }

  function closeForm(e: any) {
    e.preventDefault();
    e.target.parentNode.parentNode.classList.remove("form--open");
    const contentWrapper =
      e.target.parentNode.parentNode.parentNode.parentNode.parentNode
        .parentNode;
    if (contentWrapper.classList.contains("form--open")) {
      contentWrapper.classList.toggle("form--open");
    }
  }

  return (
    <React.Fragment>
      {response ? SetModal.FromResponse(response) : null}
      <form
        className="container form form--border form--small"
        onSubmit={handleFormSubmit}
      >
        <button onClick={closeForm} className="form__close close"></button>
        <h3 className="form__title">{isUpdate ? "Edit" : "Add New"}</h3>

        <Input
          disabled={readOnly}
          name="name"
          title="Name"
          value={year.name}
          required={true}
          type="number"
        />
        <Checkbox
          disabled={readOnly}
          name="active"
          title="Active"
          value="true"
          checked={year.active}
        />
        <div className="form__group-container">
          <Button
            disabled={readOnly}
            className="button button--blue button--icon button--save"
            title={isUpdate ? "Save" : "Send"}
          />
        </div>
      </form>
    </React.Fragment>
  );
};
export default Form;
